import { Stack, StackProps } from '@optimus-web/core';

export const FieldsContainer = (props: StackProps) => <Stack vertical spacing="200" {...props} />;

export const FullWidthFieldsContainer = (props: StackProps) => <FieldsContainer fill {...props} />;
